import yup from 'config/yup'

export default yup.object().shape({
  name: yup.string().required(),
  email: yup.string().email().required(),
  password: yup.string().min(6).required(),
  passwordConfirmation: yup.string().oneOf([yup.ref('password'), null], 'As senhas não batem'),
  phoneNumber: yup.string().matches(/^(\(?\d{2}\)?\s?)?(\d{4,5}-?\d{4})/g, 'Número inválido').required()
})
